import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const ReconciliationFormFieldsStyled = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: '24px',
  alignItems: 'flex-start',
});

export const ReconciliationFormFilesStyled = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '24px',
  alignItems: 'flex-start',
  marginBottom: '24px',
});
